<template>
  <div id="notfound">
    <NavBar></NavBar>
    <main
      role="main"
      property="mainContentOfPage"
      typeof="WebPageElement"
      class="container"
    >
      <div style="padding: 60px 40px;">
        <h1 class="title is-2">
          {{ $t("not_found.title") }}
        </h1>
        <p>
          {{ $t("not_found.text") }}
        </p>
        <ul class="list-bullet">
          <li>
            <router-link :to="{ name: 'open-services' }">{{
              $t("not_found.home")
            }}</router-link>
          </li>
          <li>
            <a href="#" @click="contactModal()">
              {{ $t("not_found.contact") }}
            </a>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ContactModal from "@/components/ContactModal.vue";
export default {
  name: "error-page",
  components: {
    NavBar
  },
  methods: {
    contactModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ContactModal,
        hasModalCard: true
      });
    }
  },
  created() {
    document.title = this.$t("message.copy_error_title");
  },
  updated() {
    document.title = this.$t("message.copy_error_title");
  }
};
</script>
<style></style>
